import React from 'react'
import { Rating, RatingPair } from '../../types/ingredient'
import { Card } from '../ui/Card'

export const RatingButton: React.FC<{ rating: Rating, isSelected: boolean, onClick: () => void }> = ({ 
  rating, 
  isSelected, 
  onClick 
}) => {
    const getColorClasses = () => {
      switch (rating) {
        case Rating.A:
          return isSelected 
            ? 'bg-green-500 text-white border-green-500' 
            : 'bg-white dark:bg-gray-800 text-green-600 dark:text-green-400 border-gray-300 dark:border-gray-600 hover:border-green-500 dark:hover:border-green-400'
        case Rating.B:
          return isSelected 
            ? 'bg-orange-500 text-white border-orange-500' 
            : 'bg-white dark:bg-gray-800 text-orange-600 dark:text-orange-400 border-gray-300 dark:border-gray-600 hover:border-orange-500 dark:hover:border-orange-400'
        case Rating.C:
          return isSelected 
            ? 'bg-red-500 text-white border-red-500' 
            : 'bg-white dark:bg-gray-800 text-red-600 dark:text-red-400 border-gray-300 dark:border-gray-600 hover:border-red-500 dark:hover:border-red-400'
      }
    }

    const getLabel = () => {
      switch (rating) {
        case Rating.A:
          return '1'
        case Rating.B:
          return '2'
        case Rating.C:
          return '3'
      }
    }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-8 h-8 rounded-full border-2 font-semibold text-sm transition-all ${getColorClasses()} ${
        !isSelected ? 'opacity-60 hover:opacity-80' : ''
      }`}
    >
      {getLabel()}
    </button>
  )
}

interface RatingSelectorProps {
  title: string
  items: string[]
  selectedRatings: RatingPair[]
  onRatingChanged: (item: string, rating: Rating | null) => void
  getLabel?: (key: string) => string
}

export const RatingSelector: React.FC<RatingSelectorProps> = ({
  title,
  items,
  selectedRatings,
  onRatingChanged,
  getLabel
}) => {
  const getRatingForItem = (item: string): Rating | null => {
    const pair = selectedRatings.find(r => r.jsonKey === item)
    return pair?.rating || null
  }

  return (
    <div className="space-y-2">
      <label className="block text-sm font-normal text-gray-700 dark:text-gray-300">
        {title}
      </label>
      <Card className="p-0">
        <div className="divide-y divide-gray-200 dark:divide-gray-700">
          {items.map((item) => {
            const currentRating = getRatingForItem(item)
            
            return (
              <div key={item} className="flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800">
                <span className="text-sm text-gray-900 dark:text-white">
                  {getLabel ? getLabel(item) : item}
                </span>
                <div className="flex gap-2">
                  {[Rating.A, Rating.B, Rating.C].map((rating) => (
                    <RatingButton
                      key={rating}
                      rating={rating}
                      isSelected={currentRating === rating}
                      onClick={() => {
                        onRatingChanged(item, currentRating === rating ? null : rating)
                      }}
                    />
                  ))}
                </div>
              </div>
            )
          })}
        </div>
      </Card>
    </div>
  )
}